;(() => {
  document.querySelectorAll('a.smooth-scroll-to').forEach((a) => {
    a.addEventListener('click', function (event) {
      event.preventDefault()
      const hash = this.getAttribute('href').split('#')[1]
      document.getElementById(hash).scrollIntoView({ behavior: 'smooth' })
    })
  })
})()
